import type { JSX } from 'react';
import React, { Fragment } from 'react';

import { ContextMenu } from '@feathr/components';
import { getIconForAction } from '@feathr/hooks';

interface IRowAction {
  action: Parameters<typeof getIconForAction>[0];
  isDestructive?: boolean;
  label: string;
  showDividerBefore?: boolean;
}

interface IRowActionsMenuProps {
  actions: readonly IRowAction[];
  onAction: (action: IRowAction['action']) => void;
}

/**
 * Configurable ContextMenu used for table-row actions across the prototype.
 * Pass an `actions` array describing the menu items and an `onAction` handler
 * that receives the chosen action id. This collapses the boilerplate of
 * rendering ContextMenu.Item for each row action.
 */
function RowActionsMenu({ actions, onAction }: Readonly<IRowActionsMenuProps>): JSX.Element {
  return (
    <ContextMenu buttonType={'icon'} position={'left-start'}>
      {actions.map((entry) => (
        <Fragment key={entry.action}>
          {entry.showDividerBefore && <ContextMenu.Divider />}
          <ContextMenu.Item
            onClick={(): void => onAction(entry.action)}
            prefix={getIconForAction(entry.action)}
            theme={entry.isDestructive ? 'danger' : undefined}
          >
            {entry.label}
          </ContextMenu.Item>
        </Fragment>
      ))}
    </ContextMenu>
  );
}

export default RowActionsMenu;
